var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 61,
    viewBox: "0 0 47 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1855_5656)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1855_5656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.18 12.6514H38.7811C41.9944 12.6514 44.626 15.6154 44.626 19.2442V53.427C44.626 57.0835 42.0221 60.0198 38.7811 60.0198H7.22988C4.01659 60.0198 1.38501 57.0558 1.38501 53.427V19.2442C1.38501 15.5877 3.98889 12.6514 7.22988 12.6514H11.108",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9473 8.46871C28.9473 5.33852 26.3989 2.79004 23.2687 2.79004H22.7146C19.5845 2.79004 17.036 5.33852 17.036 8.46871C13.9058 8.46871 11.385 10.9895 11.385 14.1197V16.5574H34.5983V14.1197C34.5983 10.9895 32.0775 8.46871 28.9473 8.46871Z",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0249 47.7764H34.9861",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0249 37.4717H34.9861",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0249 27.167H34.9861",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1855_5656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.9834,
    height: 60,
    fill: "white",
    transform: "translate(0.508301 0.905273)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1855_5656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.9834,
    height: 60,
    fill: "white",
    transform: "translate(0 1.40527)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.4c8ed61ba56d529892bf22368d3c4578.svg";
export { ForwardRef as ReactComponent };